var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTrash(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "trash",
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M15.125 15.125C15.4897 15.125 15.8394 15.2699 16.0973 15.5277C16.3551 15.7856 16.5 16.1353 16.5 16.5V33C16.5 33.3647 16.3551 33.7144 16.0973 33.9723C15.8394 34.2301 15.4897 34.375 15.125 34.375C14.7603 34.375 14.4106 34.2301 14.1527 33.9723C13.8949 33.7144 13.75 33.3647 13.75 33V16.5C13.75 16.1353 13.8949 15.7856 14.1527 15.5277C14.4106 15.2699 14.7603 15.125 15.125 15.125ZM22 15.125C22.3647 15.125 22.7144 15.2699 22.9723 15.5277C23.2301 15.7856 23.375 16.1353 23.375 16.5V33C23.375 33.3647 23.2301 33.7144 22.9723 33.9723C22.7144 34.2301 22.3647 34.375 22 34.375C21.6353 34.375 21.2856 34.2301 21.0277 33.9723C20.7699 33.7144 20.625 33.3647 20.625 33V16.5C20.625 16.1353 20.7699 15.7856 21.0277 15.5277C21.2856 15.2699 21.6353 15.125 22 15.125ZM30.25 16.5C30.25 16.1353 30.1051 15.7856 29.8473 15.5277C29.5894 15.2699 29.2397 15.125 28.875 15.125C28.5103 15.125 28.1606 15.2699 27.9027 15.5277C27.6449 15.7856 27.5 16.1353 27.5 16.5V33C27.5 33.3647 27.6449 33.7144 27.9027 33.9723C28.1606 34.2301 28.5103 34.375 28.875 34.375C29.2397 34.375 29.5894 34.2301 29.8473 33.9723C30.1051 33.7144 30.25 33.3647 30.25 33V16.5Z",
    fill: "url(#paint0_linear_1248_260)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M39.875 8.25C39.875 8.97935 39.5853 9.67882 39.0695 10.1945C38.5538 10.7103 37.8543 11 37.125 11H35.75V35.75C35.75 37.2087 35.1705 38.6076 34.1391 39.6391C33.1076 40.6705 31.7087 41.25 30.25 41.25H13.75C12.2913 41.25 10.8924 40.6705 9.86091 39.6391C8.82946 38.6076 8.25 37.2087 8.25 35.75V11H6.875C6.14565 11 5.44618 10.7103 4.93046 10.1945C4.41473 9.67882 4.125 8.97935 4.125 8.25V5.5C4.125 4.77065 4.41473 4.07118 4.93046 3.55546C5.44618 3.03973 6.14565 2.75 6.875 2.75H16.5C16.5 2.02065 16.7897 1.32118 17.3055 0.805456C17.8212 0.289731 18.5207 0 19.25 0L24.75 0C25.4793 0 26.1788 0.289731 26.6945 0.805456C27.2103 1.32118 27.5 2.02065 27.5 2.75H37.125C37.8543 2.75 38.5538 3.03973 39.0695 3.55546C39.5853 4.07118 39.875 4.77065 39.875 5.5V8.25ZM11.3245 11L11 11.1623V35.75C11 36.4793 11.2897 37.1788 11.8055 37.6945C12.3212 38.2103 13.0207 38.5 13.75 38.5H30.25C30.9793 38.5 31.6788 38.2103 32.1945 37.6945C32.7103 37.1788 33 36.4793 33 35.75V11.1623L32.6755 11H11.3245ZM6.875 8.25V5.5H37.125V8.25H6.875Z",
    fill: "url(#paint1_linear_1248_260)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1248_260",
    x1: 19.7682,
    y1: 11.0389,
    x2: 35.1691,
    y2: 16.6045,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00058B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#187BF5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1248_260",
    x1: 17.1645,
    y1: -8.7559,
    x2: 50.4472,
    y2: 3.40557,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00058B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#187BF5"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrash);
export default __webpack_public_path__ + "static/media/trash.930d202a7ab76ed75bb0d13b78639bc4.svg";
export { ForwardRef as ReactComponent };